import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { toggleSidebar } from '../store/slices/uiSlice';
import {
    HomeIcon,
    UserGroupIcon,
    PhotographIcon,
    AcademicCapIcon,
    CalendarIcon,
    UsersIcon,
    XIcon,
    BellIcon
  } from '@heroicons/react/outline';

const Sidebar = () => {
    const { sidebarOpen } = useSelector(state => state.ui);
    const { user } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    
    const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';
    
    const navigationItems = [
      { name: 'Enquiries', path: '/enquiries', icon: UserGroupIcon },
      { name: 'About Images', path: '/about-images', icon: PhotographIcon },
      { name: 'Result Images', path: '/result-images', icon: AcademicCapIcon },
      { name: 'Events', path: '/events', icon: CalendarIcon },
      { name: 'Student Life', path: '/student-life', icon: UserGroupIcon },
      { name: 'Notification', path: '/notification', icon: BellIcon, admin: true },
      { name: 'User', path: '/user', icon: UsersIcon, admin: true },      
    ];
    
    const navLinkClasses = ({ isActive }) => 
      `flex items-center px-4 py-3 text-gray-600 dark:text-gray-300 transition-colors ${
        isActive 
          ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 border-r-4 border-blue-600' 
          : 'hover:bg-gray-100 dark:hover:bg-gray-700'
      }`;
  
    return (
      <>
        {/* Overlay for mobile */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 z-20 bg-black bg-opacity-50 md:hidden"
            onClick={() => dispatch(toggleSidebar())}
          ></div>
        )}
  
        {/* Sidebar */}
        <aside 
          className={`fixed inset-y-0 left-0 z-30 w-64 bg-white dark:bg-gray-800 shadow-lg transform ${
            sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } md:translate-x-0 transition-transform duration-300 ease-in-out`}
        >
          <div className="flex items-center justify-between h-16 px-4 border-b dark:border-gray-700">
            <h2 className="text-xl font-bold text-gray-800 dark:text-white">Admin Panel</h2>
            <button 
              className="p-1 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 md:hidden"
              onClick={() => dispatch(toggleSidebar())}
            >
              <XIcon className="h-6 w-6" />
            </button>
          </div>
          
          <div className="px-2 py-4">
            <div className="mb-6 px-4">
              <div className="flex items-center">
                <div className="h-10 w-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold">
                  {user?.name?.charAt(0) || 'U'}
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-200">{user?.name || 'User'}</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 capitalize">{user?.role || 'User'}</p>
                </div>
              </div>
            </div>
            
            <nav className="space-y-1">
              {navigationItems.map((item) => {
                // Skip admin-only items for non-admin users
                if (item.admin && !isAdmin) return null;
                
                return (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    className={navLinkClasses}
                  >
                    <item.icon className="h-5 w-5 mr-3" />
                    {item.name}
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </aside>
      </>
    );
}

export default Sidebar
